<script>
import LargeBlueHotSpot from '@/src/components/svg/LargeBlueHotSpot.vue'

export default {
  components: { LargeBlueHotSpot },
  props: {
    spotSize: {
      type: String,
      default: 'small',
    },
    spotActive: {
      type: String,
      default: 'active',
    },
    posX: {
      type: Number,
      default: 0,
    },
    posY: {
      type: Number,
      default: 0,
    },
    posUnit: {
      type: String,
      default: 'px',
    },
    rotX: {
      type: Number,
      default: 0,
    },
    rotY: {
      type: Number,
      default: 0,
    },
    rotZ: {
      type: Number,
      default: 0,
    },
    fadeTime: {
      type: Number,
      default: 1000,
    },
  },
  data: () => ({
    customFade: '',
  }),
  computed: {
    spotStyle() {
      return {
        top: this.posY + this.posUnit,
        left: this.posX + this.posUnit,
        transform:
          'rotateX(' +
          this.rotX +
          'deg) rotateY(' +
          this.rotY +
          'deg) rotateZ(' +
          this.rotZ +
          'deg)',
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.customFade = 'fadeIn'
    }, this.fadeTime)
  },
  methods: {
    isPlaced() {
      if (this.posX > 0 || this.posY > 0) {
        return 'placed'
      } else {
        return 'notPlaced'
      }
    },
  },
}
</script>

<template>
  <div
    id="hot-spot"
    :class="['c-hotspot', '_test', spotSize, 'c-hotspot--' + spotActive, customFade, isPlaced()]"
    :style="spotStyle"
    v-on="$listeners"
  >
    <LargeBlueHotSpot />
  </div>
</template>

<style lang="scss">
@import '@design';


.c-hotspot {
  $block: &;

  position: absolute;
  z-index: 5;
  opacity: 0;
  transition: all 1s ease-in-out;

  // FOR TESTING PURPOSES
  // Always do position and sizing in percentage values
  // These would be relative to the size of the video

  &._test {
    top: 29.5%;
    left: 31.5%;
    width: 8%;
  }

  &.fadeIn {
    opacity: 1;
  }

  &.fadeOut {
    opacity: 0;
  }

  &.large {
      width: 220px;
      height: 220px;
  }

  &.mid {
      width: 160px;
      height: 160px;
    }

    &.small {
      width: 90px;
  height: 90px;
    }

  // Pseudo element with padding maintains aspect ratio

  &::after {
    display: block;
    padding-top: 100%;
    content: '';
  }

  @at-root {
    &__circle {
      @keyframes hotspotPulse {
        6% {
          opacity: 1;
          transform: scale(1);
        }

        10%,
        100% {
          opacity: 0;
          transform: scale(1);
        }
      }

      @keyframes hotspotCircles {
        100% {
          transform: rotate(360deg);
        }
      }

      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: visible;

      &-target,
      &-secondary,
      &-main,
      &-outer {
        fill: none;
        stroke: $brandWhite;
        vector-effect: non-scaling-stroke;
      }

      &-target,
      &-outer {
        stroke-width: 2;
      }

      &-background {
        fill: $brandWhiteTransparent;

        /* #{$block}--active & {
          fill: $brandMidBlueTransparent;
        } */
      }

      &-pulse {
        opacity: 0;
        fill: rgba($brandWhite, 0.125);
        transform: scale(0);
        transform-origin: center;

/*
        #{$block}--active & {
          animation: hotspotPulse 10s 1s infinite;
        }
        */
      }

      &-center {
        fill: $brandWhite;
      }

      &-secondary,
      &-main {
        stroke-width: 4;
        transform-origin: center;
        animation-name: hotspotCircles;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }

      &-secondary {
        animation-duration: 55s;
      }

      &-main {
        animation-duration: 50s;
        animation-direction: reverse;
      }
    }
  }
  &.c-hotspot--active {
    .c-hotspot__circle-background {
      fill: $brandMidBlueTransparent !important;
    }
  }
}
</style>
